export default "__VITE_ASSET__8v_mJopF__"